module.exports = __webpack_public_path__ + "img/1.05ba99df.png";